module.exports = __webpack_public_path__ + "static/media/map-zoom-minus-brand-refresh.05c771aa.svg";